module.exports = __webpack_public_path__ + "media/Video 93.e2882753.mp4";